var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useUncontrolledProp } from 'uncontrollable';
import { Droplist } from '@snack-uikit/list';
import { ButtonField } from '../ButtonField';
import { getPlacement } from './helpers';
import styles from './styles.module.css';
export const ButtonFieldList = forwardRef((_a, ref) => {
    var { items, selection, open, onOpenChange } = _a, rest = __rest(_a, ["items", "selection", "open", "onOpenChange"]);
    const [isOpen, setIsOpen] = useUncontrolledProp(open, false, onOpenChange);
    const placement = getPlacement(rest);
    return (_jsx(Droplist, { "data-test-id": 'button-field-list', items: items, selection: Object.assign({ mode: 'single' }, selection), open: isOpen, onOpenChange: setIsOpen, closeDroplistOnItemClick: true, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        triggerElemRef: ref, size: rest.size, placement: placement, children: _jsx(ButtonField, Object.assign({}, rest, { hasArrow: true, arrowOpen: isOpen, className: styles.triggerClassName })) }));
});
